/**
 * Download de blob no navegador — usado pelos dois fluxos de conversão STEP
 * (Conversor STEP e a importação STEP da tela Peças, os dois chamam
 * /api/step/to-mpr e baixam o resultado). Ver docs/referencia/mapas/fluxos-step.md.
 */

/**
 * Extrai o filename de um header Content-Disposition
 * (`attachment; filename="x.zip"`). Retorna null se o header não tiver
 * filename ou não existir.
 */
export const filenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null;
  const match = contentDisposition.match(/filename[^;=\n]*=["']?([^"';\n]+)["']?/i);
  return match ? match[1].trim() : null;
};

/**
 * Dispara o download de um Blob como arquivo, sem sair da página.
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
